import { useTranslation } from 'react-i18next';

import type { ConfirmationDialogContainerProps } from '@/components/dialogs/elements.confirmation-dialog';
import {
  ConfirmationDialogActionCancelButton,
  ConfirmationDialogActionProceedButton,
  ConfirmationDialogActions,
  ConfirmationDialogBodyMutedText,
  ConfirmationDialogContainer,
  ConfirmationDialogHeader,
} from '@/components/dialogs/elements.confirmation-dialog';

// ----------------------------------------------------------------------

export type ConfirmationEditDialogProps = Omit<ConfirmationDialogContainerProps, 'subject'> & {
  isLoading: boolean;
  onProceed: () => void;
};

// ----------------------------------------------------------------------

export const ConfirmationEditDialog = (props: ConfirmationEditDialogProps) => {
  const { isLoading, onClose, onProceed, ...restOfDialogProps } = props;
  const { t } = useTranslation('confirmation-dialog-elements');

  return (
    <ConfirmationDialogContainer subject="edit" onClose={onClose} {...restOfDialogProps}>
      <ConfirmationDialogHeader>{t('confirmation-edit-dialog.header')}</ConfirmationDialogHeader>

      <ConfirmationDialogBodyMutedText>{t('confirmation-edit-dialog.muted-text')}</ConfirmationDialogBodyMutedText>

      <ConfirmationDialogActions>
        <ConfirmationDialogActionCancelButton onClick={onClose} />
        <ConfirmationDialogActionProceedButton autoFocus loading={isLoading} onClick={onProceed}>
          {t('confirmation-edit-dialog.actions.save')}
        </ConfirmationDialogActionProceedButton>
      </ConfirmationDialogActions>
    </ConfirmationDialogContainer>
  );
};
